import config from "../config";
import axios from "axios";
import URL from "./url";

const getSystemTimezone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const api = {
  get: (requestData) => axios.get(requestData),

  getAuth: (requestData) =>
    axios.get(URL[config.env].examdeskApiUrl + requestData.url, {
      headers: requestData.headers,
    }),

  // New: getAuth with timezone header
  getAuthTZ: (requestData) =>
    axios.get(URL[config.env].examdeskApiUrl + requestData.url, {
      headers: {
        ...requestData.headers,
        "Timezone": getSystemTimezone(), // custom header name
      },
    }),

  getAuthresult: (requestData) =>
    axios.get(URL[config.env].apiUrl + requestData.url, {
      headers: requestData.headers,
    }),

  getAuthresultTZ: (requestData) =>
    axios.get(URL[config.env].apiUrl + requestData.url, {
      headers: {
        ...requestData.headers,
        "Timezone": getSystemTimezone(),
      },
    }),

  post: (requestData) =>
    axios.post(
      URL[config.env].examdeskApiUrl + requestData.url,
      requestData.data
    ),

  postAuthHeader: (requestData) =>
    axios.post(
      URL[config.env].examdeskApiUrl + requestData.url,
      requestData.post,
      { ...requestData.headers }
    ),

  postAuth: (requestData) =>
    axios.post(
      URL[config.env].examdeskApiUrl + requestData.url,
      requestData.data,
      {
        headers: requestData.headers,
      }
    ),

  postAuthTZ: (requestData) =>
    axios.post(
      URL[config.env].examdeskApiUrl + requestData.url,
      requestData.data,
      {
        headers: {
          ...requestData.headers,
          "Timezone": getSystemTimezone(),
        },
      }
    ),

  put: (requestData) =>
    axios.put(requestData.url, requestData.data, {
      headers: requestData.headers,
    }),

  putTZ: (requestData) =>
    axios.put(requestData.url, requestData.data, {
      headers: {
        ...requestData.headers,
        "Timezone": getSystemTimezone(),
      },
    }),
};

export default api;
